import { CircularProgress } from "@mui/joy"
import { Box, useMediaQuery, useTheme } from "@mui/material"
import React from "react"
import { getViewWidth } from "../constants/styles"
import { isInIframe } from "../utils/func"

export function PostScreenLoading() {
  const theme = useTheme()
  const isEmbedded = isInIframe()
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"))

  const topOffset = isEmbedded ? 0 : isMobile ? "5vh" : "10vh"
  const sideOffset = isEmbedded ? 0 : isMobile ? "10px" : "25px"

  return (
    <Box
      minHeight={"500px"}
      display={"flex"}
      flexDirection={"column"}
      alignItems={"center"}
      justifyContent={"flex-start"}
      position={"absolute"}
      top={topOffset}
      left={sideOffset}
      right={sideOffset}
      bottom={sideOffset}
      height={isEmbedded ? "100%" : `calc(100% - ${topOffset})`}
      zIndex={1000}
      sx={{
        padding: isEmbedded ? "0px" : { xs: "5px", sm: "5px 10px 10px 10px" },
        overflow: "auto",
      }}
    >
      {isMobile ? (
        <Box
          display={"flex"}
          flexDirection={"column"}
          height={"100%"}
          width={"100%"}
        >
          <Box flex={1} position={"relative"}>
            <div
              className="lk-video-conference-inner"
              style={{
                height: "100%",
                width: "100%",
                position: "relative",
                minHeight: "400px",
              }}
            >
              <Box
                display={"flex"}
                flexDirection={"column"}
                position={"relative"}
                borderRadius={isEmbedded ? "0px" : "1rem"}
                overflow={"hidden"}
                width={"100%"}
                height={"100%"}
                sx={{
                  backgroundColor: "rgba(255, 255, 255, 0.6)",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CircularProgress
                  color="primary"
                  determinate={false}
                  size="lg"
                  variant="plain"
                />
              </Box>
            </div>
          </Box>
        </Box>
      ) : (
        <div
          className="lk-video-conference-inner"
          style={{
            width: getViewWidth(isEmbedded),
            marginRight: "unset",
            margin: "0px auto",
            height: "100%",
            minHeight: "500px",
            display: "flex",
            flexDirection: "column",
            position: "relative",
          }}
        >
          <Box
            display={"flex"}
            flexDirection={"column"}
            position={"relative"}
            borderRadius={isEmbedded ? "0px" : "1rem"}
            overflow={"hidden"}
            width={"100%"}
            height={"100%"}
            sx={{
              backgroundColor: "rgba(255, 255, 255, 0.6)",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CircularProgress
              color="primary"
              determinate={false}
              size="lg"
              variant="plain"
            />
          </Box>
        </div>
      )}
    </Box>
  )
}
